import { render, staticRenderFns } from "./pbi-annual-sales-perfomance-export.page.vue?vue&type=template&id=f959ea12"
import script from "./pbi-annual-sales-perfomance-export.page.vue?vue&type=script&lang=ts"
export * from "./pbi-annual-sales-perfomance-export.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports